import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import careerinfoService from "../../api/careerinfoService";

// Async thunk for submitting contact form
export const career_info = createAsyncThunk(
  "/career/career_info",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await careerinfoService.career_info(payload);

      return {
        career_infoSuccess: response?.data || [],
      };
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);
export const feature_info = createAsyncThunk(
  "/career/feature_info",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await careerinfoService.feature_info(payload);

      return {
        feature_infoSuccess: response?.data || [],
      };
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);
export const benefit_info = createAsyncThunk(
  "/career/benefit_info",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await careerinfoService.benefit_info(payload);

      return {
        benefit_infoSuccess: response?.data || [],
      };
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);

// Initial state
const initialState = {
  career_infoItems: {},
  feature_infotems: {},
  benefit_infoItems: {},
  isLoading: false,
  isSuccess: false,
  isError: false,
  errorMessage: "",
  successMessage: "",
};

const careerSlice = createSlice({
  name: "career",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(career_info.pending, (state) => {
        state.isLoading = true;
        state.isError = false;
        state.isSuccess = false;
        state.errorMessage = "";
      })
      .addCase(career_info.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.career_infoItems = action.payload.career_infoSuccess || "";
        state.errorMessage = "";
      })
      .addCase(career_info.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.errorMessage = action.payload;
      })
      .addCase(feature_info.pending, (state) => {
        state.isLoading = true;
        state.isError = false;
        state.isSuccess = false;
        state.errorMessage = "";
      })
      .addCase(feature_info.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.feature_infoItems = action.payload.feature_infoSuccess || "";
        state.errorMessage = "";
      })
      .addCase(feature_info.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.errorMessage = action.payload;
      })
      .addCase(benefit_info.pending, (state) => {
        state.isLoading = true;
        state.isError = false;
        state.isSuccess = false;
        state.errorMessage = "";
      })
      .addCase(benefit_info.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.benefit_infoItems = action.payload.benefit_infoSuccess || "";
        state.errorMessage = "";
      })
      .addCase(benefit_info.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.errorMessage = action.payload;
      });
  },
});

export default careerSlice.reducer;
